import React from "react";
import PropTypes from "prop-types";

// Limitless imports
import Grid from "@limitless/modern/layout/Grid";
import DropdownMenu from "@limitless/modern/inputs/dropdown-menu/DropdownMenu";
import CheckBox from "@limitless/modern/inputs/checkbox/CheckBox";
import { useExpertAvailableQuestionsContext } from "@limitless/expert";
import { SimpleAccordion } from "@limitless/portal";

// Limitless Icons
import CommonFilterPoper from "../filters/CommonFilterPoper";
import { checkBoxStyling, commonRatingFilter } from "../rating-dashboard/Filters";

export const commonCheckboxDetails = [
    {
        key: "responded",
        onLabel: "Responded",
        offLabel: "Responded",
        id: "respondedCheckBox"
    },
    {
        key: "incentive",
        onLabel: "Incentive",
        offLabel: "Incentive",
        id: "IncentiveCheckBox"
    },
    {
        key: "adjustment",
        onLabel: "Adjustment",
        offLabel: "Adjustment",
        id: "AdjustmentCheckBox"
    },
    {
        key: "forwarded",
        onLabel: "Forwarded",
        offLabel: "Forwarded",
        id: "forwardedCheckbox"
    },
    {
        key: "reviewed",
        onLabel: "Reviewed",
        offLabel: "Reviewed",
        id: "reviewedCheckBox"
    }
];

export const RenderAccordion = ({ title, keyValue, showDivider, children }) => {
    const classes = commonRatingFilter();
    const [expanded, setExpanded] = React.useState(null);

    const handleFilterChange = key => {
        const filterValue = expanded === key ? null : key;
        setExpanded(filterValue);
    };

    return (
        <SimpleAccordion
            key={title}
            title={title}
            variant="body2"
            rootStyle={classes.summaryRoot}
            classes={classes}
            showDivider={showDivider}
            handleAccordionClick={() => handleFilterChange(keyValue)}
            expanded={keyValue === expanded}
        >
            {children}
        </SimpleAccordion>
    );
};

const AvailableFilters = ({ clickAwayClose }) => {
    const {
        availableFilterExists,
        availableRewardGroups,
        availableFilters,
        updateAvailableFilters,
        clearAvailableFilters
    } = useExpertAvailableQuestionsContext();

    const { selectedGroups } = availableFilters;

    const avalibleFilters = React.useMemo(() => {
        return commonCheckboxDetails.map(item => ({
            ...item,
            checked: availableFilters[item.key],
            onChange: () => updateAvailableFilters({ [item.key]: !availableFilters[item.key] })
        }));
    }, [availableFilters]);

    return (
        <>
            <CommonFilterPoper
                label="Filter rewards"
                clickAwayClose={clickAwayClose}
                filterExists={availableFilterExists}
                title={"Filter by:"}
                clearFilters={clearAvailableFilters}
            >
                <Grid item xs={12}>
                    <RenderAccordion title="Group" keyValue="filter-01" showDivider>
                        <DropdownMenu
                            ListboxComponent="ul"
                            fullWidth
                            options={availableRewardGroups}
                            value={selectedGroups}
                            onChange={(e, items) =>
                                updateAvailableFilters({
                                    selectedGroups: items
                                })
                            }
                            multiple
                            disableClearable={false}
                            placeholder="Select group"
                            id="groupDropdownFilter"
                        />
                    </RenderAccordion>
                </Grid>
                <Grid item xs={12}>
                    <RenderAccordion title="Reward type" keyValue="filter-02" showDivider={false}>
                        <Grid container sx={{ rowGap: 1, marginBottom: 1 }} display="flex" flexDirection="column">
                            {avalibleFilters.map(option => {
                                return (
                                    <CheckBox
                                        key={option.id}
                                        onLabel={option.onLabel}
                                        offLabel={option.offLabel}
                                        onChange={option.onChange}
                                        checked={option.checked}
                                        variantStyling={checkBoxStyling}
                                        id={option.id}
                                    />
                                );
                            })}
                        </Grid>
                    </RenderAccordion>
                </Grid>
            </CommonFilterPoper>
        </>
    );
};

AvailableFilters.propTypes = {
    clickAwayClose: PropTypes.bool
};
RenderAccordion.propTypes = {
    title: PropTypes.string,
    showDivider: PropTypes.bool,
    keyValue: PropTypes.string,
    children: PropTypes.node
};

export default AvailableFilters;
